<template>
  <!-- Transition pour l'animation de la modal -->
  <transition name="modal">
    <div
      class="sef-modal-mask"
      v-if="isShowModal"
      v-show="
        this.autoLoadedScopes ||
        this.$props.preselectedScope == null ||
        this.$props.preselectedScope.length == 0
      "
    >
      <div class="card" :class="type">
        <div class="card-header">
          <div class="card-title">
            <!-- Icône et titre de l'en-tête -->
            <i :class="icon" style="font-size: 25px" />
            <p style="margin-left: 4px">{{ headerTitle }}</p>
          </div>
          <div class="btn-actions-pane-right">
            <p class="modal-information" v-html="information"></p>
            <div class="btn-group-sm btn-group" role="group">
              <!-- Bouton de fermeture de la modal -->
              <a href="#" class="active btn btn-focus" @click="Cancel(null)">
                <i class="scf-close"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="card-body-container">
            <!-- Contenu de la modal -->
            <div>
              <div class="form-group">
                <div class="sp-container">
                  <!-- Sélection du client -->
                  <label class="spc-label" for="clientCombo">{{
                    clientComboLabel
                  }}</label>
                  <div class="_spc-content">
                    <wj-combo-box
                      ref="selectRef"
                      id="clientCombo"
                      displayMemberPath="name"
                      :itemsSource="clients"
                      :textChanged="handleClientChanged"
                      :selectedItem="this.client"
                      :isRequired="false"
                      :is-disabled="clients.length <= 1"
                    />
                  </div>
                </div>

                <div
                  v-if="isShowSubdivision && itemsSource.length"
                  :key="selectsContainerKey"
                >
                  <!-- Sélection de sous-divisions en fonction du client -->
                  <div v-for="(level, index) in levels" :key="level">
                    <div class="sp-container">
                      <label class="spc-label" for="clientMultiCombo">{{
                        level
                      }}</label>
                      <div class="_spc-content">
                        <wj-multi-select
                          :key="index"
                          :id="'multiSelect-' + index"
                          :placeholder="`Tous ${level}`"
                          :headerFormat="'{count:n0} éléments sélectionnés'"
                          :is-disabled="isSelectionDisabled(itemsSource, index)"
                          displayMemberPath="name"
                          selectedValuePath="scope"
                          display-member-path="name"
                          checkedMemberPath="checked"
                          :checkedItems="selectedItems[index]"
                          :itemsSource="itemsSource[index]"
                          :showSelectAllCheckbox="itemsSource[index].length > 1"
                          :showFilterInput="itemsSource[index].length > 1"
                          :checkedItemsChanged="
                            (value) => handleOnCheckedItemsChanged(index, value)
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <!-- Boutons d'annulation et de confirmation -->
          <button type="button" class="btn btn-primary" @click="Cancel()">
            {{ labels.cancel }}
          </button>
          <button type="button" class="btn btn-primary" @click="save()">
            {{ labels.save }}
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import "@grapecity/wijmo.styles/wijmo.css";
import "@grapecity/wijmo.vue2.core";
import * as wjcCore from "@grapecity/wijmo";
import { WjComboBox, WjMultiSelect } from "@grapecity/wijmo.vue2.input";
import Environment from "@/../config";
import ScopeHelper from "@/_helpers/ScopeHelper";
//import ScopeHelper from "@/_helpers/ScopeHelper";

export default {
  name: "PerimeterModal",
  inject: ["loggedInUser"],
  components: {
    WjComboBox,
    WjMultiSelect,
  },

  emits: ["cancel", "validate", "update:projects"],

  props: {
    preselectedScope: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    information: {
      type: String,
      default: null,
    },
    // Propriétés de la modal
    isShowModal: {
      type: Boolean,
      default: false,
    },
    headerTitle: String,
    clientComboLabel: String,
    projects: Array,
    clients: {
      type: Array,
      validator: function (value) {
        const expectedProperties = ["name"]; // Propriétés attendues
        if (
          !Array.isArray(value) ||
          !value.every((item) =>
            expectedProperties.every((prop) => prop in item)
          )
        ) {
          console.warn(
            'Invalid prop: "data" must be an array of objects with specific properties.'
          );
          return false;
        }
        return true;
      },
      required: true,
    },
    onItemChanged: Function,
    onCheckedItemsChanged: Function,
    labels: {
      default: { cancel: "Cancel", save: "Confirm" },
    },
    selectedIndex: {
      type: Number,
      default: -1,
    },
  },

  data() {
    return {
      selectsContainerKey: 0,
      forcedPreselectedScopes: this.preselectedScope,
      latestScopes: this.preselectedScope,
      latestSelectedClient: null,
      reseted: false,
      isFirstLoad: true,
      client: null,
      levels: [],
      originalProjectData: [],
      showSubdivision: false,
      selectedItems: [],
      oldSelectedItems: [],
      oldSelectedClient: [],
      itemsSource: [],
      autoLoadedScopes: false,
      config: Environment,
    };
  },
  watch: {
    projects(newVal) {
      // Observer les changements dans la liste des projets
      if (newVal.length > 0) {
        this.originalProjectData = newVal[0];
        this.levels = this.originalProjectData.levels;

        this.InitData();
        this.showSubdivision = true;
      } else {
        this.originalProjectData = [];
        this.levels = [];

        this.InitData();
        this.showSubdivision = false;
      }
    },

    selectedIndex(newVal) {
      this.localSelectedIndex = newVal;
    },

    clients(newVal) {
      // Observer les changements dans la liste des clients
      this.preselectedClient(newVal);
      if (newVal.length == 1) {
        this.client = newVal[0];
      }
    },
  },

  methods: {
    isSelectionDisabled(itemsSource, index) {
      const optionsSource = itemsSource[index];
      const isDisabled =
        optionsSource &&
        optionsSource.length == 1 && // on a une seule option
        itemsSource.length - 1 == index; // nous sommes dans le dérnier niveau
      return isDisabled;
    },
    isPreselectedScope() {
      return (
        this.forcedPreselectedScopes != null &&
        this.forcedPreselectedScopes.length > 0
      );
    },
    preselectedClient(clients) {
      const preselectedClient = clients.filter((client) =>
        this.preselectedScopes().includes(client.scope)
      );
      if (preselectedClient && preselectedClient.length > 0) {
        if (
          this.latestSelectedClient != preselectedClient[0] &&
          this.clients.length == 1
        )
          this.handleClientChanged({ selectedValue: preselectedClient[0] });
        this.latestSelectedClient = preselectedClient[0];
        this.client = preselectedClient[0];
      } else if (clients.length == 1) {
        this.client = clients[0];
        this.handleClientChanged({ selectedValue: clients[0] });
      } else {
        // the preselected scope does not exists and the user has many choices => let him choose
        // this happens when a scope is deleted or the user play with the local storage
        ScopeHelper.resetForUser(this.loggedInUser);
        this.forcedPreselectedScopes = [];
      }
    },
    preselectedItems(level, items) {
      if (!items) return [];

      const result = items.filter((item) =>
        this.preselectedScopes().includes(item.scope)
      );
      this.selectedItems[level] = result;
    },
    InitData() {
      this.levels.forEach((level, index) => {
        const itemsForLevel = this.getItemsForLevel(index);
        this.preselectedItems(index, itemsForLevel);
        this.itemsSource[index] = itemsForLevel;
      });
      this.onCheckedItemsChanged(this.getAllCheckedItemsAcrossLevels());
      if (
        this.isFirstLoad &&
        !this.autoLoadedScopes &&
        this.isPreselectedScope()
      ) {
        this.isFirstLoad = false;
        this.autoLoadedScopes = true;
        this.save();
      }
      if (this.isFirstLoad) {
        this.isFirstLoad = false;
      }
    },
    isHighstLevel(scope) {
      const pattern = /^ALL\.[A-Za-z0-9]+$/;
      return pattern.test(scope);
    },
    getItemsForLevel(levelIndex) {
      // Récupérer les éléments pour le niveau spécifié
      return this.extractItemsForLevel(
        this.originalProjectData.hierarchy,
        levelIndex,
        0
      );
    },

    extractItemsForLevel(node, targetLevelIndex, currentLevelIndex) {
      if (currentLevelIndex === targetLevelIndex) {
        // Si c'est le niveau cible, retourner les enfants de ce nœud
        return this.clients.length == 1 &&
          !this.isHighstLevel(this.clients[0].scope)
          ? this.formatData([node], targetLevelIndex)
          : this.formatData(node.children, targetLevelIndex);
      } else if (node.children && node.children.length > 0) {
        // Si ce n'est pas le niveau cible, continuer à descendre dans la hiérarchie
        let items = [];
        node.children.forEach((child) => {
          items = items.concat(
            this.extractItemsForLevel(
              child,
              targetLevelIndex,
              currentLevelIndex + 1
            )
          );
        });
        return this.formatData(items, targetLevelIndex);
      }
      return []; // Si aucun enfant, retourner une liste vide
    },
    handleOnCheckedItemsChanged(levelIndex, event) {
      this.selectedItems[levelIndex] = event.checkedItems;

      // Mettre à jour les sélections des niveaux suivants
      if (levelIndex < this.levels.length - 1) {
        for (let i = levelIndex + 1; i < this.levels.length; i++) {
          this.itemsSource[i] = this.updateItemsForNextLevel(i);
        }
      }

      if (levelIndex > 0 && this.selectedItems[levelIndex - 1].length === 0) {
        for (let i = levelIndex - 1; i >= 0; i--) {
          this.itemsSource[i] = this.updateItemsForPrevLevel(i);
        }
      }
      if (
        levelIndex + 1 == this.levels.length - 1 &&
        this.itemsSource[levelIndex + 1] &&
        this.itemsSource[levelIndex + 1].length == 1
      ) {
        this.selectedItems[levelIndex + 1] = this.itemsSource[levelIndex + 1];
        this.selectsContainerKey++;
      }
      this.onCheckedItemsChanged(this.getAllCheckedItemsAcrossLevels());
    },

    formatData(children, targetLevelIndex) {
      return children.map((child) => ({
        name: child.name,
        scope: child.scope,
        children: child.children,
        checked: false,
        level: targetLevelIndex,
      }));
    },

    updateItemsForPrevLevel(prevLevelIndex) {
      if (prevLevelIndex < 0 || prevLevelIndex >= this.levels.length - 1) {
        return this.itemsSource[prevLevelIndex];
      }

      const currentLevelSelection = this.selectedItems[prevLevelIndex + 1];
      if (!currentLevelSelection || currentLevelSelection.length === 0) {
        return this.itemsSource[prevLevelIndex];
      }

      const itemsPrevLevel = this.getItemsForLevel(prevLevelIndex);
      const currentLevelScopes = currentLevelSelection.map(
        (item) => item.scope
      );

      // Filtrez les éléments du niveau précédent en fonction des scopes des sélections actuelles
      return itemsPrevLevel.map((prevLevelItem) => {
        const isParentSelected = currentLevelScopes.some((scope) =>
          scope.startsWith(prevLevelItem.scope)
        );
        return {
          ...prevLevelItem,
          checked: isParentSelected,
        };
      });
    },

    updateItemsForNextLevel(nextLevelIndex) {
      const parentSelection = this.selectedItems[nextLevelIndex - 1];
      if (!parentSelection || parentSelection.length === 0) {
        return this.getItemsForLevel(nextLevelIndex);
      }

      const parentScopes = parentSelection.map((item) => item.scope);

      let combineArray = [
        ...this.selectedItems[nextLevelIndex],
        ...this.getItemsForLevel(nextLevelIndex),
      ];

      let uniqueMap = new Map();
      combineArray.forEach((objet) => {
        if (!uniqueMap.has(objet.scope)) {
          uniqueMap.set(objet.scope, objet);
        }
      });

      return Array.from(uniqueMap.values()).filter((item) =>
        parentScopes.some((parentScope) => item.scope.startsWith(parentScope))
      );
    },

    getAllCheckedItemsAcrossLevels() {
      let allCheckedItems = [];

      allCheckedItems.push({
        key: "Client",
        value: [this.client.name],
      });

      //if (this.isSelectedItemsEmpty()) return allCheckedItems;
      for (
        let i = 0;
        i < this.levels.length && i < this.selectedItems.length;
        i++
      ) {
        let levelKey = this.levels[i];
        let checkedItemsAtThisLevel = this.selectedItems[i].map((e) => e.name);
        let obj = {};
        obj["key"] = levelKey;
        obj["value"] = checkedItemsAtThisLevel;
        allCheckedItems.push(obj);
      }
      return allCheckedItems;
    },
    removeItemByIndex(array, index) {
      if (index >= 0 && index < array.length) {
        array.splice(index, 1);
      }
    },
    handleClientChanged(combo) {
      // Gérer le changement de client dans la boîte de combo
      if (!this.isFirstLoad) {
        this.forcedPreselectedScopes = [];
        this.selectedItems = [];
        // ScopeHelper.resetForUser(this.loggedInUser);
      }
      this.client = combo.selectedValue;
      var clientSelected = [
        {
          key: "Client",
          value: [this.client.name],
        },
      ];
      let result = {
        checkedItem: clientSelected,
        selectedIndex: combo.selectedIndex,
        selectedValue: combo.selectedValue,
      };
      this.onItemChanged(result);
    },
    isSelectedItemsEmpty() {
      if (!this.selectedItems || this.selectedItems == []) return true;
      let isEmpty = false;
      let indexes = [];
      this.selectedItems.forEach((item, index) => {
        if (!item || item == [] || item.length == 0) {
          isEmpty = true;
          indexes.push(index);
        }
      });
      indexes.forEach((i) => this.removeItemByIndex(this.selectedItems, i));
      return isEmpty;
    },
    findScopesWithoutChildren(data) {
      let scopesWithoutChildren = [];

      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].length; j++) {
          let hasChild = false;
          let currentScope = data[i][j].scope;

          if (i + 1 < data.length) {
            for (let k = 0; k < data[i + 1].length; k++) {
              let childScope = data[i + 1][k].scope;
              if (childScope.startsWith(currentScope)) {
                hasChild = true;
                break;
              }
            }
          }

          if (!hasChild) {
            scopesWithoutChildren.push(currentScope);
          }
        }
      }

      return scopesWithoutChildren;
    },

    getSelectedScope(data) {
      const lastCheckedArray = [...data]
        .reverse()
        .find((subArray) => subArray.some((e) => e.checked));

      return (
        lastCheckedArray
          ?.filter((e) => e.checked)
          .map(({ name, scope, level }) => ({
            name,
            scope,
            level,
          })) || []
      );
    },

    save: function () {
      this.oldSelectedItems = this.getAllCheckedItemsAcrossLevels();
      const scopes = this.findScopesWithoutChildren(this.selectedItems);
      this.$emit("validate", {
        scopesByLevels: this.getAllCheckedItemsAcrossLevels(),
        client: this.client,
        levels: this.levels,
        scopes: scopes,
      });

      var shouldRefresh = false;
      if (
        this.oldSelectedClient &&
        this.oldSelectedClient.name &&
        this.oldSelectedClient.name !== this.client.name
      ) {
        shouldRefresh = true;
      }

      this.oldSelectedClient = this.client;
      this.latestScopes = scopes;

      if (shouldRefresh) {
        const routesToMatch = ["equipmentDetail", "FileProcessingDetails"];
        if (routesToMatch.includes(this.$route.name)) {
          let newUrl = window.location.href;
          switch (this.$route.name) {
            case "equipmentDetail":
              newUrl = newUrl.replace(
                /(equipmentdetail)(\/.*)?$/i,
                "equipmentList"
              );
              break;
            case "FileProcessingDetails":
              newUrl = newUrl.replace(
                /(FileProcessingDetails)(\/.*)?$/i,
                "FileProcessing"
              );
              break;
          }
          window.location.href = newUrl;
        } else {
          window.location.reload();
        }
      }
    },

    Cancel: function () {
      // Fonction d'annulation
      this.forcedPreselectedScopes = this.latestScopes;
      this.client = this.oldSelectedClient;
      this.$emit("cancel", this.oldSelectedItems);
    },
    getSumOfSuperiorLevels(inputStrings) {
      if (inputStrings == null || inputStrings.length == 0) return [];
      const uniqueSuperiorLevels = new Set(
        inputStrings
          .flatMap((inputString) =>
            inputString
              .split(".")
              .map((level, index, levels) =>
                levels.slice(0, index + 1).join(".")
              )
          )
          .filter((level) => level !== "ALL")
      );

      return [...uniqueSuperiorLevels];
    },
    preselectedScopes() {
      return this.getSumOfSuperiorLevels(this.forcedPreselectedScopes);
    },
  },
  computed: {
    isShowSubdivision() {
      const routesToMatch = ["fileProcessing", "FileProcessingDetails"];
      if (routesToMatch.includes(this.$route.name)) return false;
      return this.showSubdivision;
    },
  },
  created() {
    wjcCore.setLicenseKey(this.config.value("VUE_APP_WIJMO_LICENCE"));
  },
  mounted() {
    if (this.clients.length > 0) {
      this.preselectedClient(this.clients);
    }
  },
};
</script>

<style scoped>
/* @import url("../fonts/fonts.css"); */
.sef-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: 0.1 0.3s ease;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: "D-DIN";
  width: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: transparent;
}

.card.full {
  width: 80%;
}

.card.notif .card-title {
  margin-right: 15px !important;
}

.card.notif .modal-footer {
  justify-content: center;
}

.card.confirmation {
  width: 30%;
}

.modal-footer .btn-primary {
  background-color: #eee !important;
  padding: 5px 30px;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #e2e6ec !important;
}

.card .card-header {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  border-bottom-width: 1px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
  padding-left: 10px;
  height: 35px;
  background-color: #bbdbfd;
  border-radius: 6px 6px 0px 0px;
  font-size: 12pt;
  font-weight: bold;
  border-bottom: 2px solid #1973d2;
  box-sizing: unset !important;
}

.card .card-header p {
  margin-top: revert !important;
  margin-bottom: revert !important;
  font-size: 12pt !important;
}

.card .card-header a {
  border: none;
  box-shadow: none;
}

.card-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0 !important;
  color: black;
}

.card .btn-actions-pane-right {
  margin-left: auto;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.card .card-header .btn-group,
.btn-group-vertical {
  position: relative;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}

.card .card-header a {
  text-decoration: none;
}

.card .card-header a.btn.btn-focus i {
  /* margin-left: 10px;
        margin-right: 10px; */
  color: #1973d2;
  font-size: 12pt;
}

.card .card-header a.btn.btn-focus i:hover {
  opacity: 0.5;
}

.card-body {
  padding: unset !important;
}

.card .card-body-container {
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: auto;
  background: #f4f6fb;
  max-height: 680px;
}

.card .card-body-container p {
  font-size: 11pt;
}

.card.full .card-body-container {
  height: 70vh;
}

.card .notif .card-body-container {
  height: auto;
}

/* .card.confirmation .card-body-container{
        height: 100px;
    } */

.card .modal-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
  background: #f4f6fb;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s;
}

.btn-primary {
  color: #030f40;
  background-color: #eeeeee;
  border: 1px solid #030f40 !important;
}

.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

.btn-primary:hover {
  color: #030f40;
  background-color: #dddddd;
  border-color: #030f40;
}

.modal-footer > :not(:last-child) {
  margin-right: 0.25rem;
}

.modal-enter,
.modal-leave-to {
  opacity: 0;
}

.modal-information {
  font-weight: normal;
}

.wj-content.wj-dropdown {
  width: 100%;
}

.highlight {
  margin-bottom: 0;
  color: white;
  background-color: #343a40;
  width: 25%;
  padding-top: 2px;
}

.row {
  margin-bottom: 15px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mt-15 {
  margin-top: 15px;
}

.ml-15 {
  margin-left: 15px;
}

.sp-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-evenly;
  align-content: center;
  gap: 10px;
  padding: 10px;
  min-width: 300px;
  color: black;
}

.spc-label {
  flex: 1;
}

.spc-content {
  flex: 2;
}

.spc-content select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;
  background: #fff;
  background-image: none;
  flex: 1;
  padding: 0 0.5em;
  color: #000000;
  cursor: pointer;
  font-size: 14px;
  padding-right: 40px;
  padding-left: 10px;
}

.spc-content select::-ms-expand {
  display: none;
}

.spc-content {
  position: relative;
  display: flex;
  width: auto;
  height: 30px;
  line-height: 30px;
  background: #fff;
  overflow: hidden;
  border-radius: 5px;
  font-family: "D-DIN";
}

.spc-content::after {
  content: "\25BC";
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 8px;
  background: #fff;
  cursor: pointer;
  pointer-events: none;
  transition: 0.25s all ease;
  border-left: 1px solid #eee;
}
</style>
